<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<h1 class="ct2" id="p0014-01-0">
<a id="page14">
<b>43</b>
</a></h1><a id="page14">
<h2 class="ct1">Never give up on anybody.<br/> Miracles happen every day.</h2>
</a></section><a id="page14">
</a></div>
<a id="page14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?e8aea240